import initialstate from '../initialstate';

import {
	GET_ALL_ACCOUNTS,
	GET_ALL_COMPONENTS,
	GET_ALL_SCOPES,
	POST_NEW_COMPONENT,
	SEND_LINK_REQUEST,
	PUT_COMPONENT,
	GET_INSTRUCTIONS,
	SET_ACCOUNTS_PARAMETERS,
	POST_INSTRUCTIONS,
	UPDATE_INSTRUCTIONS,
	PATCH_SECTIONS,
	POST_NEW_SECTION,
	GET_ASSIGNED_SCOPES,
	DELETE_COMPONENT,
	POST_GACOMPONENT_ACCOUNT,
	DELETE_GACOMPONENT_ACCOUNT,
	GET_GROUP_SNAPSHOT_BY_ID,
	GET_ALL_SNAPSHOTS,
	DELETE_INSTRUCTION,
	POST_SNAPSHOTS,
	DELETE_CUSTOM_SECTION,
	POST_SEND_INSTRUCTIONS,
	CREATE_ENTITY_FORM,
	CLEAN_COMPONENTS_AND_FORMACTIONS,
	CLEAN_GROUP_SNAPSHOT,
	SET_GROUP_AUDIT_DOCUMENT_UPLOAD,
	DELETE_DOCUMENT_BY_ID,
	DELETE_SUB_SCOPE,
	POST_SUB_SCOPE,
	PATCH_SUB_SCOPE
} from '../../actions/actiontypes';

import groupComponentsReducer from './GroupComponents';
import groupInstructionsReducer from './GroupInstructions';
import groupScopesReducer from './GroupScopes';
import groupAccountsReducer from './GroupAccounts';
import assignedScopesReducer from './AssignedScopes';
import groupSnapshotsReducer from './GroupSnapshots';
import groupSnapshotsGetSnapshotByIdReducer from './GroupSnapshot';

export default function groupAuditReducer(state = initialstate.groupAudit, action) {
	switch (action.type) {
		case GET_ALL_ACCOUNTS:
		case SET_ACCOUNTS_PARAMETERS:
		case POST_GACOMPONENT_ACCOUNT:
		case DELETE_GACOMPONENT_ACCOUNT: {
			return {...state, accounts: groupAccountsReducer(state.accounts, action)};
		}
		case POST_NEW_COMPONENT:
		case SEND_LINK_REQUEST:
		case GET_ALL_COMPONENTS:
		case DELETE_COMPONENT:
		case PUT_COMPONENT:
		case POST_SEND_INSTRUCTIONS:
		case CREATE_ENTITY_FORM:
		case CLEAN_COMPONENTS_AND_FORMACTIONS: {
			// Renders Group involvement summary table with up-to-date data.
			return {...state, components: groupComponentsReducer(state.components, action)};
		}
		case GET_ALL_SCOPES:
		case POST_SUB_SCOPE:
		case PATCH_SUB_SCOPE: {
			return {...state, scopes: groupScopesReducer(state.scopes, action)};
		}
		case DELETE_SUB_SCOPE: {
			return {
				...state,
				assignedScopes: assignedScopesReducer(state.assignedScopes, action),
				scopes: groupScopesReducer(state.scopes, action)
			};
		}
		case GET_ASSIGNED_SCOPES: {
			return {...state, assignedScopes: assignedScopesReducer(state.assignedScopes, action)};
		}
		case DELETE_DOCUMENT_BY_ID:
		case PATCH_SECTIONS:
		case POST_NEW_SECTION:
		case DELETE_CUSTOM_SECTION:
		case POST_INSTRUCTIONS:
		case UPDATE_INSTRUCTIONS:
		case DELETE_INSTRUCTION:
		case GET_INSTRUCTIONS: {
			return {...state, sections: groupInstructionsReducer(state.sections, action)};
		}
		case GET_GROUP_SNAPSHOT_BY_ID:
		case CLEAN_GROUP_SNAPSHOT: {
			return {...state, groupSnapshots: groupSnapshotsGetSnapshotByIdReducer(state.groupSnapshots, action)};
		}
		case POST_SNAPSHOTS:
		case GET_ALL_SNAPSHOTS: {
			return {...state, snapshots: groupSnapshotsReducer(state.snapshots, action)};
		}
		case SET_GROUP_AUDIT_DOCUMENT_UPLOAD: {
			const newObject = {
				engagementId: action.engagementId,
				sectionId: action.sectionId,
				instructionId: action.instructionId
			};
			return {...state, groupAuditDocumentUploadOn: newObject};
		}
		default:
			return state;
	}
}
